<template>
  <Intro />
  <HealthSolutions />
  <WhatWeDo />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/corporate/CorporateIntro.vue";
import WhatWeDo from "@/components/corporate/WhatWeDo.vue";
import HealthSolutions from "@/components/corporate/HealthSolutions.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

